export default {
  methods: {
    determineActivityFacing(activity) {
      return this.$api.getActivityDetails(activity.id, activity.revisionId).then(response => {
        const activityObj = response.data;
        let isSiteFacing;
        const selectedRoles = activityObj.result && activityObj.result.completedBy;

        if (selectedRoles) {
          selectedRoles.forEach(role => {
            if (role == "Patient/Participant" || role == "Observer/Caregiver") {
              isSiteFacing = false;
            } else {
              isSiteFacing = true;
            }
          });
          return isSiteFacing;
        }
      });
    },
    determineActivity(activity) {
      const activityObj = activity;
      let isSiteFacing;
      const selectedRoles = activityObj.completedBy;
      if (selectedRoles) {
        selectedRoles.forEach(role => {
          if (role == "Patient/Participant" || role == "Observer/Caregiver") {
            isSiteFacing = false;
          } else {
            isSiteFacing = true;
          }
        });
        return isSiteFacing;
      }
    }
  }
};
